<!----- ############## Header ############### ----->

<body>
    <div class="p-4 d-flex justify-content-between sticky-header">
        <div class="logo">
            <img [src]="logo" alt="logo">
        </div>

        <div class="d-flex justify-content-end align-items-center">
            <button [style]='style.btnstyle' style="margin-right: 4px;" routerLink="/login"
                class="d-none d-md-block">Login</button>
            <button [style]='style.btnstyle' routerLink="/register" class="d-none d-md-block">Sign Up</button>
            <img *ngIf="displayHamburger else close" [src]="hamburger" (click)="toggleHamburger()" alt="hamburger"
                class="d-block d-md-none">
            <ng-template #close>
                <div [src]="hamburger" [style]="style.color" (click)="toggleHamburger()" alt="hamburger"
                    style="font-size: 18px;" class="d-block d-md-none text-right"><i class="fa fa-close"></i></div>
                <div style="position: absolute; top:8vh; right: 0px;"
                    class="card p-4 d-flex flex-column justify-content-center align-items-center d-md-none">
                    <button [style]='style.btnstyle' class="w-100" style="margin-right: 4px;"
                        routerLink="/login">Login</button>
                    <button [style]='style.btnstyle' class="hamburger-child" routerLink="/register">Sign Up</button>
                </div>
            </ng-template>
        </div>
    </div>
    <section class="section d-md-flex firstsection" [style]="style.landingpage.firstsection">
        <div class="headersection">
            <h4 class="d-inline" [innerHTML]="data.landingpage.firstsection.text1"></h4>
            <h4 class="d-inline"><span [innerHTML]="data.landingpage.firstsection.text2" [style]="style.color"
                    style="font-weight: bolder;"></span></h4>
            <h4 class="d-inline" [innerHTML]="data.landingpage.firstsection.text3"></h4>
            <div>
                <br />
                <div *ngFor="let bullet of data.landingpage.firstsection.bulletpoints">
                    <span><img src="../../assets/assets/images/green-tick.svg" alt="green tick"></span>
                    <p class="d-inline p-0">{{bullet}}</p>
                    <br /><br />
                </div>
            </div>
            <button routerLink="/register" [style]="style.btnstyle" class="w-md-50 py-3">Create an account</button>
        </div>
        <div class="d-none d-md-flex justify-content-start align-items-center" style="width: 50%;">
            <img [src]="data.landingpage.firstsection.image1" class="" alt="banner image">
            <img id="studentbanner" class="" [src]="data.landingpage.firstsection.image2" alt="banner image">
        </div>
    </section>
    <div class="section" *ngIf="courses?.length > 0">
        <h5 class="text-center secondsection-heading mt-0" [style]="style.color">
            {{data.landingpage.secondsection.header}}</h5>
        <hr>
        <div class="course-container">
            <div class="card course mb-4"  *ngFor="let c of courses">
                <h5 class="card-title text-center">{{c}}</h5>
                <!-- <p class="card-title text-center" >{{c}}   </p> -->
            </div>
        </div>
    </div>
    <div id="plans" class="section text-light">
        <h5 class="text-center mt-0">Choose a plan that works for you</h5>
        <p class="text-center text-light mb-2">Flexible pricing that meets your needs</p>
        <br>
        <div class="d-flex justify-content-center align-items-center">
            <img src="../../assets/assets/images/Line1.svg" alt="" class="d-sm-none d-md-block">
            <img src="../../assets/assets/images/Line1b.svg" class="d-sm-block d-md-none">
            <p class="text-center text-light mx-5 mb-0" style="font-size: smaller !important;">INDIVIDUAL PLANS</p>
            <img src="../../assets/assets/images/Line2.svg" alt="" class="d-sm-none d-md-block">
            <img src="../../assets/assets/images/Line2b.svg" alt="" class="d-sm-block d-md-none">
        </div>
        <div
            class="mt-5 d-flex flex-column flex-md-row flex-wrap {{data.plans.length > 1 ? 'justify-content-around': 'justify-content-center'}} align-items-center">
            <div *ngFor="let plan of data.plans">
                <div class="planitem p-5 my-2">
                    <img [src]="plan.iconpath" alt="">
                    <br><br>
                    <div class="mt-3">
                        <p class="text-uppercase" style="color: #B8C2F6 !important;">{{plan.title}}</p>
                    </div>
                    <br>
                    <div>
                        <h5 class="text-light d-inline">{{plan.currency}}{{plan.price}}</h5>
                    </div>
                    <br>
                    <div>
                        <i class="fa fa-check d-inline" aria-hidden="true"></i>
                        <p class="d-inline" style="color: #B8C2F6 !important;"> {{plan.attempts}} attempts</p>
                    </div>
                    <br>
                    <div>
                        <i class="fa fa-check d-inline" aria-hidden="true"></i>
                        <p class="d-inline" style="color: #B8C2F6 !important;"> Valid for {{plan.validity}}</p>
                    </div>
                </div>
            </div>
        </div>
        <br>
        <div class="d-flex justify-content-center align-items-center" *ngIf="data?.exclusiveplans?.length > 0">
            <img src="../../assets/assets/images/Line1.svg" alt="" class="d-sm-none d-md-block">
            <img src="../../assets/assets/images/Line1b.svg" class="d-sm-block d-md-none">
            <p class="text-center text-light mx-5 mb-0" style="font-size: smaller !important;">ENTERPRISE PLANS</p>
            <img src="../../assets/assets/images/Line2.svg" alt="" class="d-sm-none d-md-block">
            <img src="../../assets/assets/images/Line2b.svg" alt="" class="d-sm-block d-md-none">
        </div>
        <div *ngIf="data?.exclusiveplans?.length > 0"
            class="mt-5 d-flex flex-column flex-md-row {{data.exclusiveplans.length > 1 ? 'justify-content-between': 'justify-content-center'}} align-items-center">
            <div *ngFor="let plan of data.exclusiveplans">
                <div class="planitem p-5">
                    <img [src]="plan.iconpath" alt="">
                    <br><br>
                    <div class="mt-3">
                        <p class="text-uppercase" style="color: #B8C2F6 !important;">{{plan.title}}</p>
                    </div>
                    <br>
                    <div>
                        <h5 *ngIf="data.landingpage.showexclusiveplanprice else exclpln;" class="text-light d-inline">
                            {{plan.currency}}{{plan.price}}
                        </h5>
                        <ng-template #exclpln class="text-light d-inline">
                            <h5 class="text-light d-inline">Please Contact Us</h5>
                        </ng-template>
                    </div>
                    <br>
                    <div>
                        <i class="fa fa-check d-inline" aria-hidden="true"></i>
                        <p class="d-inline" style="color: #B8C2F6 !important;"> {{plan.attempts}} attmepts</p>
                    </div>
                    <br>
                    <div>
                        <i class="fa fa-check d-inline" aria-hidden="true"></i>
                        <p class="d-inline" style="color: #B8C2F6 !important;"> Valid for {{plan.validity}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div id="stat" class="text-light d-none d-md-flex justify-content-between p-5" >
            <h5>
                20,000+ Users
            </h5>
            <h5>
                50,000+ Assesments
            </h5>
            <h5>
                10,000+ Questions
            </h5>
        </div> -->

    <div id="contactus" *ngIf="data.landingpage.showcontactus"
     class="section d-flex flex-column justify-content-center">
        <div class="d-flex flex-column flex-md-row justify-content-center">
            <img src="../../assets/assets/images/60460.svg" alt="">
            <form class="p-3" style="max-height: 100%;">
                <h3>Contact us</h3>
                <p class="opacit">Get in touch with us today. Send us a message.</p>
                <div class="form-group mb-3">
                    <input type="text" placeholder="Enter Name" [(ngModel)]="name" name="name"
                        class="form-control input-sm">
                </div>
                <div class="form-group mb-3">
                    <input type="text" name="email" placeholder="Enter Email Address" [(ngModel)]="email"
                        class="form-control input-sm">
                </div>
                <div class="form-group mb-3">
                    <input type="tel" name="phoneNumber" placeholder="Enter Mobile Number" [(ngModel)]="phoneNumber"
                        class="form-control input-sm">
                </div>
                <div class="form-group mb-3">
                    <textarea rows="5" placeholder="Write a brief summary of your project" [(ngModel)]="message"
                        class="form-control input-sm"></textarea>
                </div>

                <div class="form-group">
                    <button type="submit" [style]="style.btnstyle" class="w-fit-content py-3" (click)="SendMail()" [disabled]="loading">Send message &nbsp; <i class="fa fa-envelope" aria-hidden="true"></i></button>
                    <div id="status" *ngIf="loading">
                        <div class="spinner mt-2">
                            <i class="fa fa-spinner spin-icon" style="font-size: large ;"></i>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div id="footer" class="p-5">
        <p class="text-light text-center m-0">Copyright Prephub © 2024</p>
    </div>
</body>